import { Controller } from '@hotwired/stimulus';

// Auto-dismisses a FlashComponent after a few seconds, or on manual close
// (the button's data-action="click->toast#hide"). The fade-out itself is
// `.flash--dismissed` in flash.css, not utility classes spelled out here.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.hide(), 6000);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  hide() {
    clearTimeout(this.timeout);
    this.element.classList.add('flash--dismissed');
    setTimeout(() => this.element.remove(), 300);
  }
}
